import { getSortedCollection, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useEncodeSpecificationApi } from "../../../../../common/api/orders-api/encode-specification/useEncodeSpecificationApi";
import { DataHooksQueryKey } from "../../../../../common/data/data-hooks/DataHooksQueryKey";
import { EncodeSpecification, mapToEncodeSpecification } from "../../../../../common/types/EncodeSpecification";

export const useEncodeSpecifications = (): SprintQueryResult<EncodeSpecification[]> => {
    const { getEncodeSpecificationsLookup } = useEncodeSpecificationApi();

    return useSprintQuery<EncodeSpecification[]>({
        queryKey: [DataHooksQueryKey.EncodeSpecifications],
        queryFn: async (): Promise<EncodeSpecification[]> => {
            const response = await getEncodeSpecificationsLookup();
            const newItems = response.items.map(mapToEncodeSpecification);
            return getSortedCollection(newItems, "name");
        }
    });
};
